import React, { useLayoutEffect, useRef, useState } from 'react';
import { DATA_TEST_IDS } from '../consts';
import type { MediafileSettingsPanelProps } from './types';
import styles from '../index.module.scss';

export const MediafileSettingsPanel: React.FC<MediafileSettingsPanelProps> = ({ id, settings, triggerRef }) => {
  const panelRef = useRef<HTMLDivElement>(null);
  const [hasFocusWithin, setHasFocusWithin] = useState(false);
  useLayoutEffect(() => {
    if (!settings.isExpanded && hasFocusWithin) {
      // Commit the existing leaf's blur before hiding it, including external collapses.
      const activeElement = document.activeElement;
      if (activeElement instanceof HTMLElement && panelRef.current?.contains(activeElement)) {
        activeElement.blur();
        triggerRef.current?.focus();
      }
      setHasFocusWithin(false);
    }
  }, [settings.isExpanded, hasFocusWithin, triggerRef]);
  return (
    <div
      ref={panelRef}
      id={settings.panelId}
      className={styles.panel}
      data-testid={DATA_TEST_IDS.SETTINGS_PANEL(id)}
      role="region"
      aria-labelledby={DATA_TEST_IDS.SETTINGS_TRIGGER(id)}
      hidden={!settings.isExpanded && !hasFocusWithin}
      onFocusCapture={() => setHasFocusWithin(true)}
      onBlurCapture={(event) => {
        if (!event.currentTarget.contains(event.relatedTarget as Node | null)) setHasFocusWithin(false);
      }}>
      {settings.content}
    </div>
  );
};
